export const FETCH_PLANNING_ALERTS_REQUEST = 'FETCH_PLANNING_ALERTS_REQUEST';
export const FETCH_PLANNING_ALERTS_SUCCESS = 'FETCH_PLANNING_ALERTS_SUCCESS';
export const FETCH_PLANNING_ALERTS_FAILURE = 'FETCH_PLANNING_ALERTS_FAILURE';

export const FETCH_PLANNING_ALERT_REQUEST = 'FETCH_PLANNING_ALERT_REQUEST';
export const FETCH_PLANNING_ALERT_SUCCESS = 'FETCH_PLANNING_ALERT_SUCCESS';
export const FETCH_PLANNING_ALERT_FAILURE = 'FETCH_PLANNING_ALERT_FAILURE';

export const CREATE_PLANNING_ALERT_REQUEST = 'CREATE_PLANNING_ALERT_REQUEST';
export const CREATE_PLANNING_ALERT_SUCCESS = 'CREATE_PLANNING_ALERT_SUCCESS';
export const CREATE_PLANNING_ALERT_FAILURE = 'CREATE_PLANNING_ALERT_FAILURE';

export const UPDATE_PLANNING_ALERT_REQUEST = 'UPDATE_PLANNING_ALERT_REQUEST';
export const UPDATE_PLANNING_ALERT_SUCCESS = 'UPDATE_PLANNING_ALERT_SUCCESS';
export const UPDATE_PLANNING_ALERT_FAILURE = 'UPDATE_PLANNING_ALERT_FAILURE';

export const DELETE_PLANNING_ALERT_REQUEST = 'DELETE_PLANNING_ALERT_REQUEST';
export const DELETE_PLANNING_ALERT_SUCCESS = 'DELETE_PLANNING_ALERT_SUCCESS';
export const DELETE_PLANNING_ALERT_FAILURE = 'DELETE_PLANNING_ALERT_FAILURE';

export const SET_CURRENT_PLANNING_REPORT = 'SET_CURRENT_PLANNING_REPORT';

export const FETCH_PLANNING_REPORT_REQUEST = 'FETCH_PLANNING_REPORT_REQUEST';
export const FETCH_PLANNING_REPORT_SUCCESS = 'FETCH_PLANNING_REPORT_SUCCESS';
export const FETCH_PLANNING_REPORT_FAILURE = 'FETCH_PLANNING_REPORT_FAILURE';

export const FETCH_PLANNING_ALERT_REPORTS_REQUEST = 'FETCH_PLANNING_ALERT_REPORTS_REQUEST';
export const FETCH_PLANNING_ALERT_REPORTS_SUCCESS = 'FETCH_PLANNING_ALERT_REPORTS_SUCCESS';
export const FETCH_PLANNING_ALERT_REPORTS_FAILURE = 'FETCH_PLANNING_ALERT_REPORTS_FAILURE';